import React from "react";
import styles from "./acceptModal.scss";
import close from "../../../../assets/images/close-icon.svg";

const hireModal = ({ onHide, modalClick }) => (
  <div className={styles.modalcontainer}>
    <img src={close} className={styles.closebutton} onClick={() => onHide()} />
    <div className={styles.modalcontent}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          Are you sure you want to accept this SOW?
        </h2>
      </div>
      <div className={styles.divider}>
        <div className={styles.top} />
        <div className={styles.bottom} />
      </div>
      <div className={styles.intro}>
        <div>
          <button
            className={styles.acceptButton}
            onClick={() => {
              modalClick();
              onHide();
            }}
          >
            {" "}
            YES{" "}
          </button>
        </div>
        <div className={styles.buttonContainer}>
          <span className={styles.link} onClick={() => onHide()}>
            Cancel
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default hireModal;



// WEBPACK FOOTER //
// ./src/routes/employer/memberProposal/components/acceptModal.js